import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import Download from "@/pages/Download";
import Contact from "@/pages/Contact";
import WhyTechnoSort from "@/pages/WhyTechnoSort";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import Refund from "@/pages/legal/Refund";
import Shipping from "@/pages/legal/Shipping";
import EULA from "@/pages/legal/EULA";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/why" element={<WhyTechnoSort />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/checkout/:planId" element={<Checkout />} />
            <Route path="/success" element={<Success />} />
            <Route path="/download" element={<Download />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/eula" element={<EULA />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
